import React from 'react';
import { object, string, func, bool } from 'prop-types';
import { getToolIds } from '../../util/tool';
import { getConfigObject } from '../../util/config';
import { getPathfinderUrl } from '../../util/util';
import ReadAndPracticeOverviewWidget from './OverviewWidgetComponents/ReadAndPracticeOverviewWidget';
import PathFinderDiagnosticsWidget from './OverviewWidgetComponents/PathFinderDiagnosticsWidget';

/**
 * Component that renders the appropriate widgets for Read and Practice courses.
 *
 * - Includes a static widget and optionally the Pathfinder static widget.
 *
 * @param {*} props
 * @returns
 */
const RPWidgetsContainer = (props) => {
  const { DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET, DASHBOARDS_ENABLED_110 } = getConfigObject();
  if ((!DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET && !DASHBOARDS_ENABLED_110) || props.isSectionManager) {
    return null;
  }

  const { reports, courseId, onTabChange } = props;

  const pathfinderTools = [getToolIds().pathfinder2, getToolIds().pathfinder];
  const hasPathfinder = pathfinderTools.some(tool => reports.courseAbstract.toolIds.includes(tool));

  return (<React.Fragment>
    <ReadAndPracticeOverviewWidget btnText="View performance" onTabChange={onTabChange} />
    {hasPathfinder &&
    <PathFinderDiagnosticsWidget diagnosticsUrl={getPathfinderUrl(courseId)} /> }
  </React.Fragment>);
};
RPWidgetsContainer.propTypes = {
  reports: object,
  courseId: string,
  onTabChange: func,
  isSectionManager: bool,
};

export default RPWidgetsContainer;
